import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PolarJServerModelContextPath } from '../constants';
import { PagingData, ShoppingCartPayload, UseraccountModel } from '../models';
import { Address } from '../models/address.model';
import {
  AmmFavoriteBackend,
  AmmShoppingCartBackEnd,
} from '../models/catalog.model';
import { MODULE_SERVICE_NAME } from './../constants/app.constant';
import { PolarJService } from './polarj.service';

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartService {
  private _polarjService: PolarJService = inject(PolarJService);
  updateShoppingCart(
    shoppingCarts: ShoppingCartPayload
  ): Observable<AmmShoppingCartBackEnd> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.SHOPPINGCART,
      modelName: PolarJServerModelContextPath.THE_CART,
      requestMappingString: 'updateCart',
      para: shoppingCarts,
      singleData: true,
    });
  }
  //TODO: need to passing in the paging filter

  getShoppingCart(): Observable<PagingData<AmmShoppingCartBackEnd>> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.SHOPPINGCART,
      modelName: PolarJServerModelContextPath.THE_CART,
      pageData: true,
      enableErrorMsg: true,
    });
  }

  updateFavorites(
    favorites: ShoppingCartPayload
  ): Observable<PagingData<boolean>> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.SHOPPINGCART,
      modelName: PolarJServerModelContextPath.AM_FAVOURITES,
      requestMappingString: 'batchUpdate',
      para: favorites,
    });
  }
  //TODO: need to passing in the paging filter
  getFavorites(): Observable<PagingData<AmmFavoriteBackend>> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.SHOPPINGCART,
      modelName: PolarJServerModelContextPath.AM_FAVOURITES,
      requestMappingString: 'merch',
      pageData: true,
    });
  }

  getBuyerInfo(): Observable<UseraccountModel> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.SHOPPINGCART,
      modelName: PolarJServerModelContextPath.AM_BUYERS,
      singleData: true,
    });
  }

  changeBuyerInfo(buyer: UseraccountModel): Observable<UseraccountModel> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.SHOPPINGCART,
      modelName: PolarJServerModelContextPath.AM_BUYERS,
      requestMappingString: buyer.id?.toString(),
      para: buyer,
      singleData: true,
    });
  }

  getAllAddress(desc: boolean = true): Observable<PagingData<Address>> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.SHOPPINGCART,
      modelName: PolarJServerModelContextPath.ADDRESSS,
      requestMappingString: 'mine',
      urlPara: desc ? 'sorts=updatedDate desc' : undefined,
      pageData: true,
    });
  }

  createNewAddress(address: Address): Observable<Address> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.SHOPPINGCART,
      modelName: PolarJServerModelContextPath.ADDRESSS,
      para: address,
      singleData: true,
    });
  }

  changeAddress(address: Address, isRemove?: boolean): Observable<Address> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.SHOPPINGCART,
      modelName: PolarJServerModelContextPath.ADDRESSS,
      requestMappingString: isRemove
        ? `${address.id}/remove`
        : address.id?.toString(),
      para: isRemove ? null : address,
      singleData: true,
    });
  }

  searchFavorites(text: string): Observable<PagingData<AmmFavoriteBackend>> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.SHOPPINGCART,
      modelName: PolarJServerModelContextPath.AM_FAVOURITES,
      requestMappingString: 'search',
      para: { type: 'MERCH', smartSearchText: text },
      pageData: true,
    });
  }
  addProductSubscribe(productCode: string, userEmail: string): Observable<boolean> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.SHOPPINGCART,
      modelName: PolarJServerModelContextPath.AM_SHOPPINFCARTS,
      requestMappingString: 'outOfStock/subscribe',
      urlPara:'email=' + userEmail+'&merchCode='+productCode,
      singleData: true,
    });
  }
}
